import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import styles from "./styles.scss";

function Search(props: Props) {
  const { t } = useTranslation();

  return (
    <input
      type="text"
      className={styles.search}
      placeholder={t("common.filterMenu.search")}
      onChange={({ target }) => props.setSearch(target.value)}
    />
  );
}

export { Search };
